import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/ManageSessions.css';
import api from '../utils/axiosConfig';

const ManageSessions = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        // First get all collection names
        const response = await api.get(`/api/sessions/list`);
        setSessions(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching sessions:', error);
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  const handleDelete = async (sessionName) => {
    if (window.confirm(`Are you sure you want to delete "${sessionName}"?`)) {
      try {
        await api.delete(`/api/sessions/${sessionName}`);
        setSessions(sessions.filter(s => s !== sessionName));
      } catch (error) {
        console.error('Error deleting session:', error);
        alert('Failed to delete session');
      }
    }
  };

  if (loading) return <div className="profile-container">Loading sessions...</div>;

  return (
  <div className="manage-container">
    <div className="manage-header">
      <h1>Sitzungen</h1>
      <div className="header-actions"> 
      </div>
    </div>
    
    <div className="sessions-content">
      {sessions.length === 0 ? (
        <div className="no-results">
          <i className="no-results-icon">📅</i>
          <p>Keine Sitzungen gefunden</p>
        </div>
      ) : (
        <div className="manage-table-wrapper">
        <table className="manage-table">
          <thead>
            <tr>
              <th>Sitzungsname</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map(sessionName => (
              <tr key={sessionName}>
                <td>{sessionName}</td>
                <td className="action-buttons">
                  <button
                    onClick={() => navigate(`/dashboard/sessions/edit/${encodeURIComponent(sessionName)}`)}
                    className="action-button edit-button"
                  >
                    Bearbeiten
                  </button>
                  <button 
                    onClick={() => handleDelete(sessionName)} 
                    className="action-button delete-button"
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  </div>
);
};

export default ManageSessions;